import { TextField } from "@mui/material"
import { useTranslation } from 'react-i18next'
import { capitaliseText } from "../../../helpers/StringHelpers"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

function CardNameInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const value = event.target.value

        const filteredValue = value.replace(/[^A-Za-z\s]/g, ``)
        handleChange(capitaliseText(filteredValue))
    }

    return (
        <TextField
            fullWidth
            id="nric-card-name-input"
            label={t(`card_name`)}
            variant="outlined"
            margin="normal"
            value={defaultValue}
            error={errorText !== undefined}
            helperText={errorText ? t(errorText) : ``}
            onChange={handleOnChange}
            onBlur={handleOnChange}
            inputProps={{ maxlength: 26, textTransform: `uppercase` }}
            disabled={isDisabled}
        />
    )
}

export default CardNameInputField
